<template>
  <files
    :files='files'
    :title='title'
    :disabled='disabled'
    :is_uploading='is_uploading'
    @add='addFile'
    :send_file_enabled='true'
    @sendFile='sendFile'
    :show_description="true"
  />
</template>

<script>
import Files from './Files';
import filesAPI from '@/api/files';
import { ESTIMATE } from '@/api/files';

export default {
  name: 'estimate-files',
  props: {
    files: {
      required: true
    },
    estimate_id: {
      required: true
    },
    loading: {
      required: false,
      type: Boolean,
      default: false
    },
    disabled: {
      required: false,
      type: Boolean,
      default: false
    },
    title: {
      required: false,
      type: String,
      default: 'Estimate Files'
    }
  },
  data: () => ({
    file_to_be_uploaded: null,
    is_uploading: false
  }),
  methods: {
    async addFile(file_type, file_to_be_uploaded, description){
        console.log(description);
        this.is_uploading = true;
        const response = await filesAPI.getPresignedURL(file_to_be_uploaded.name, ESTIMATE, this.estimate_id, file_type);
        await filesAPI.uploadToAWS(response.url, file_to_be_uploaded);
        this.is_uploading = false;
        this.files.push(response.file);
    },
    async sendFile(file_pk){
      filesAPI.sendEstimateFile(file_pk, this.estimate_id);
    }
  },
  components: {
    'files': Files
  }
}
</script>
